<template lang="pug">
#app
  .main-wrapper.main-wrapper-1
    .navbar-bg
    navbar
    sidebar
    .main-content
      router-view
</template>

<script>
import navbar from "@/components/layout/navbar.vue";
import sidebar from "@/components/layout/sidebar.vue";

export default {
  components: {
    navbar,
    sidebar
  }
};
</script>

<style lang="scss" scoped>
</style>
  